import axios from "axios";
import Constants from "./Constants";
import { constructQueryUrl } from "./Utils";

/**
 * Create Cognito AI metadata (similar to createImage)
 */
export const createCognitoAi = async (payload) => {
  return axios.post(Constants.PUBLISH_COGNITO_AI_METADATA, payload);
};

/**
 * Update Cognito AI upload status (similar to updateImageUploadStatus)
 */
export const updateCognitoAiUploadStatus = async (payload) => {
  return axios.put(
    Constants.PUBLISH_COGNITO_AI_METADATA_UPLOAD_STATUS,
    payload,
  );
};

/**
 * Get list of Cognito AI uploads with pagination and filtering
 */
export const getCognitoAiList = async ({ queryKey }) => {
  const [
    _,
    page,
    pageSize,
    field,
    sort,
    filterValue,
    columns,
    extraFilters,
    fetchAll,
  ] = queryKey;

  let query =
    Constants.LIST_COGNITO_AI +
    `?custid=${
      localStorage?.selectedCustomer
    }&page=${page}&take=${pageSize}&sortby=${field}&order=${sort.toUpperCase()}`;

  if (fetchAll) {
    query = `${query}&fetchAll=true`;
  }

  query = constructQueryUrl({ filterValue, query, columns });
  return await axios.get(query);
};

/**
 * Get single Cognito AI upload detail by ID
 */
export const getCognitoAiUploadDetail = async (uploadId) => {
  const url = `${Constants.COGNITO_AI_BASE}/${uploadId}?custid=${localStorage?.selectedCustomer}`;
  const { data } = await axios.get(url);
  return data;
};

/**
 * Get Cognito AI upload by file name
 */
export const getCognitoAiByFileName = async ({ queryKey }) => {
  const url = Constants.DESCRIBE_COGNITO_AI_BY_FILE_NAME.replace(
    ":filename",
    encodeURI(queryKey?.[1]?.name),
  );
  const { data } = await axios.get(url);
  return data;
};

/**
 * Get Cognito AI upload by ID
 */
export const getCognitoAiById = async ({ queryKey }) => {
  const [_, id] = queryKey;
  const url = Constants.DESCRIBE_COGNITO_AI.replace(":id", id);
  const { data } = await axios.get(url);
  return data;
};

/**
 * Get list of product variants
 */
export const getCognitoAiVariants = async () => {
  const url = `${Constants.COGNITO_AI_VARIANTS}?custid=${localStorage?.selectedCustomer}`;
  const { data } = await axios.get(url);
  return data;
};

/**
 * Validate version for a product variant
 */
export const validateCognitoAiVersion = async (productVariant, version) => {
  const url = `${Constants.COGNITO_AI_VALIDATE_VERSION}?productVariant=${encodeURIComponent(productVariant)}&version=${encodeURIComponent(version)}&custid=${localStorage?.selectedCustomer}`;
  const { data } = await axios.get(url);
  return data;
};

/**
 * Check for updates for a specific product variant
 */
export const checkCognitoAiUpdates = async (productVariant) => {
  const url = `${Constants.COGNITO_AI_CHECK_UPDATE}?productVariant=${productVariant}&custid=${localStorage?.selectedCustomer}`;
  const { data } = await axios.get(url);
  return data;
};

export const getCognitoAiImageReport = async () => {
  let query = Constants.COGNITO_AI_IMAGE_REPORT;
  return await axios.get(query);
};
